const markerhandleComponent = {
  init: function () {
    this.el.sceneEl.addEventListener('markerFound', () => {
      const instructionElement = document.getElementById('instruction_screen');
      if (instructionElement) {
        instructionElement.style.display = 'none';
      }
      this.videoAutoPlay();
    });

    this.el.sceneEl.addEventListener('markerLost', () => {
      this.videoPause();
    });
  },

  videoPause() {
    const videos = document.querySelectorAll('video');
    for (let video of videos) {
      const videoEntityId = video.getAttribute('video_entity_id');
      if (videoEntityId) {
        const videoEntity = document.getElementById(videoEntityId);
        if (videoEntity) {
          const playBtnPlane = videoEntity.querySelector('.play-btn');
          const thumbnailEntity = videoEntity.querySelector('.video-thumbnail');
          video.pause();
          playBtnPlane.setAttribute('visible', 'true');
          thumbnailEntity.setAttribute('visible', 'true');
        }
      }
    }
  },

  videoAutoPlay() {
    const videos = document.querySelectorAll('video');
    for (let video of videos) {
      const videoEntityId = video.getAttribute('video_entity_id');
      const autoplay = video.getAttribute('video_autoplay');
      if (autoplay == 'true' && videoEntityId) {
        const videoEntity = document.getElementById(videoEntityId);
        if (videoEntity) {
          const playBtnPlane = videoEntity.querySelector('.play-btn');
          const thumbnailEntity = videoEntity.querySelector('.video-thumbnail');
          video.play().then(() => {
            playBtnPlane.setAttribute('visible', 'false');
            thumbnailEntity.setAttribute('visible', 'false');
          });
        }
      }
    }
  },
};

export { markerhandleComponent };
